
import { message, Modal } from 'ant-design-vue'
import { h, createVNode } from 'vue'
import { COU_regOneStr } from "@/utils/co_util"
import api from './api'

// 合格的链接map
const linkMap = {
	// taote: 'market.m.taobao.com',
	// taoteShort1: 'u.ltao.com',
	// taoteShort2: 'qwbev.net',
	// tianmao: 'detail.tmall.com',
	// taobao: 'item.taobao.com',
	tb1688: 'detail.1688.com/offer',
	tb1688m: 'm.1688.com/offer',
	tb1688Short: 'qr.1688.com'	
}

// 根据平台获取商品详情链接格式
function getPlatformUrl(type, id) {
	let url = ''
	switch (type) {
		// case 6:
		// 	url = `https://market.m.taobao.com/app/ltao-fe/ltao-lite/productdetail.html?ft=t&id=${id}&ex_outchal=ZZB_01`
		// 	break
		case 5:
			url = `https://detail.1688.com/offer/${id}.html`
			break
	}
	return url
}

// 判断是否是链接格式
function isUrl(link) {
	const reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/
	return reg.test(link)
}

// 判断链接是否符合要要求
function isPassCheckUrl(link) {
  let isPass = false
  for (let key in linkMap) {
		// 如果链接是符合要求的就标记下, 并退出循环
    if (link.includes(linkMap[key])) {
			isPass = true
			break
		}
	}
  return isPass
}

// 获取商品链接对应的平台
function getUrlPlatform(link) {
  let platform 
	if (link.includes(linkMap.taoteShort1) || link.includes(linkMap.taoteShort2)) platform = 'taote'
	else if (link.includes(linkMap.tb1688Short)) platform = 'ali'
  return platform
}

// 根据短链接获取最终的商品链接
async function getUrlForShortUrl({ link, platform }) {
  const { link: l, success, msg } = await api.GetGoodsTrueUrl(link, platform)
	if (!success) return { msg: msg || '无法获取最终商品链接'}
  return { url: l }
}

// 根据链接判断是属于哪个平台的链接
function getPlatformType(link) {
  let type = 6 // 淘特
  if (link.includes('detail.1688.com/offer') || link.includes('m.1688.com/offer')) type = 5
  return type
}

// 弹出提示框提示用户输入的字符哪些是不符合要求的
function showConfirm(content) {
	return new Promise(resolve => {
		Modal.warning({
			class: 'taote-url-confirm-modal',
			title: `温馨提示，以下 ${content.length} 个字符/链接 不符合要求，将会忽略以下字符/链接`,
			content: createVNode('div', { style: 'color:red;' }, content),
			okText: '确定',
			onOk() {
				resolve(true)
			}
		})
	})
}

// 判断输入的字符是否是链接格式以及得到最终的商品链接数据
async function getLinkResult(link) {
	if (!isUrl(link)) return '不是链接格式'
	if (!isPassCheckUrl(link)) return '不是【1688】的商品详情链接' 
	const platform = getUrlPlatform(link)
  // platform 有说明是短链接, 需要获取最终的商品链接
	if (platform) {
    const { url, msg } = await getUrlForShortUrl({ link, platform })
    if (msg) return msg
    link = url
	}
  const type = getPlatformType(link)
	const id = COU_regOneStr(link, /\?id=(\d+)/) || COU_regOneStr(link, /&id=(\d+)/) || COU_regOneStr(link, /1688.com\/offer\/(\d+).html/)
	return { link: getPlatformUrl(type, id), id }
}

// 得到最终的商品链接列表
async function GetFinalGoodsUrls({ text, goodsTemplateId }) {
	if (!text) return message.warning('请先输入商品详情链接')
	if (!goodsTemplateId) return message.warning('请先选择一个商品模板')
	const arr = text.trim().split('\n').filter(item => item)
	let finalArr = [], errorArr = [], errorIndex = 0
	for (let item of arr) {
		item = item.trim()
		const result = await getLinkResult(item)
		if (typeof result === 'object') finalArr.push(result)
		else {
			errorIndex++
			errorArr.push(h('p', `序号：${errorIndex}，内容：${item}，原因：${result}`))
		}
	}
	if (errorIndex) await showConfirm(errorArr)
	return finalArr
}

export default {
  GetFinalGoodsUrls
}